import { ChainSwimlaneSchema } from './process-chain.schema';
const SWIMLANE_RANK = new Map(ChainSwimlaneSchema.options.map((swimlane, rank)=>[
        swimlane,
        rank
    ]));
const bySwimlaneThenOrder = (a, b)=>(SWIMLANE_RANK.get(a.swimlane) ?? Infinity) - (SWIMLANE_RANK.get(b.swimlane) ?? Infinity) || a.order - b.order || a.processId.localeCompare(b.processId);
/**
 * Depth-first: a chain's own mappings, by swimlane rank then `order` then
 * process id, before its children, which go by name then id. A process reached
 * twice keeps its FIRST occurrence, so the path it is reported under stays
 * stable however often it is mapped.
 *
 * `visited` is not an optimization: a `parentChainId` cycle comes back out of
 * `$graphLookup` as mutual children, and the write-path `checkCircularReference`
 * guard only covers the chain use-cases — a migration or a tenant copy can seed
 * one. Without it this walk recurses until the stack overflows.
 */ export function flattenChainMembers(root, adapter) {
    const members = [];
    const seen = new Set();
    const visited = new Set();
    const byName = (a, b)=>adapter.nameOf(a).localeCompare(adapter.nameOf(b)) || adapter.idOf(a).localeCompare(adapter.idOf(b));
    const walk = (chain, path)=>{
        const id = adapter.idOf(chain);
        if (visited.has(id)) return;
        visited.add(id);
        const chainPath = [
            ...path,
            adapter.nameOf(chain)
        ];
        const mappings = [
            ...adapter.mappingsOf(chain)
        ].sort(bySwimlaneThenOrder);
        for (const mapping of mappings){
            if (seen.has(mapping.processId)) continue;
            seen.add(mapping.processId);
            members.push({
                ...mapping,
                chainPath
            });
        }
        for (const child of [
            ...adapter.childrenOf(chain)
        ].sort(byName)){
            walk(child, chainPath);
        }
    };
    walk(root, []);
    return members;
}

//# sourceMappingURL=chain-members.js.map